import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const SHIPPING_ADDRESS_URL = `${CART_URL}/line-items`;

export async function updateLineItemQuantity(
  lineItemId: string,
  quantity: number
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';

  return await httpClient.patch(
    `${SHIPPING_ADDRESS_URL}/${lineItemId}/quantity?expand=${expandParam}`,
    {
      quantity
    }
  );
}
